import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "conditions v-theme--light" }
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = { style: {"font-size":"13px","color":"gray","font-weight":"bold"} }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal"}
}
const _hoisted_10 = { class: "d-flex search-buttons" }

import OperationOfficeAutoComplete from "@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue"
import getOperationOffice from "@/types/responses/getOperationOffice"
import { Ref, ref, computed } from 'vue'
import i18n from '@/lang/i18n';

const operationOfficeType = "App\\Models\\OperationOffice"

export default /*@__PURE__*/_defineComponent({
  __name: 'AllowAccessOfficeSearchForm',
  props: {
    loading: { type: Boolean }
  },
  emits: ['search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const hide: Ref<boolean> = ref(false)
const operationOffice: Ref<getOperationOffice | undefined> = ref()
const accountName: Ref<string | null> = ref(null)
const status: Ref<string | null> = ref('only-active')

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchBtnLabel = computed(() => {
  return props.loading ?
    i18n.global.t('pages.common.button.loading'):
    i18n.global.t('pages.common.button.exec')
})

function handleClickSearch() {
  const params = {
    type_class: operationOfficeType,
    officeable_id: operationOffice.value?.id ?? null,
    account_name: accountName.value,
    status: status.value
  }
  emits('search', params)
}

function clearForm() {
  operationOffice.value = undefined
  accountName.value = null
  status.value = 'only-active'
}

function toggleSidebar() {
  hide.value = !hide.value
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(OperationOfficeAutoComplete, {
          modelValue: operationOffice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operationOffice).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          class: "pt-2",
          label: _unref(i18n).global.t('pages.allowAccessOffice.accountName'),
          modelValue: accountName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountName).value = $event)),
          outlined: "",
          "hide-details": "auto"
        }, null, 8, ["label", "modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.common.filter.status.title')), 1),
          _createVNode(_component_v_radio_group, {
            modelValue: status.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event)),
            "hide-details": "auto",
            class: "radio-group-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                "hide-details": "auto",
                value: "only-active",
                label: _unref(i18n).global.t('pages.common.filter.status.onlyActive'),
                color: "blue"
              }, null, 8, ["label"]),
              _createVNode(_component_v_radio, {
                "hide-details": "auto",
                value: "all",
                label: _unref(i18n).global.t('pages.common.filter.status.all'),
                color: "blue"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("defs", null, [
              _createElementVNode("path", {
                id: "path-1650848226989195",
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1),
            _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
              _createElementVNode("path", {
                style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1)
          ]))]))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            style: _normalizeStyle({
              backgroundColor : props.loading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchBtnLabel.value), 1)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            onClick: clearForm
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" リセット ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ], 2)
  ], 2))
}
}

})